import getters from './getters';
import actions from './actions';
import mutations from './mutations';
var state = () => ({
  seller: null
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};